/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const authenticationEventsParamsPersonIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const authenticationEventsParamsFromRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$',
);
export const authenticationEventsParamsToRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$',
);
export const authenticationEventsParamsCursorMax = 512;

export const authenticationEventsParamsCursorRegExp = new RegExp('^[A-Za-z0-9_-]+$');
export const authenticationEventsParamsLimitDefault = 50;
export const authenticationEventsParamsLimitMax = 100;

export const AuthenticationEventsParams = zod.object({
  personId: zod.uuid().regex(authenticationEventsParamsPersonIdRegExp).optional(),
  from: zod.iso.datetime({ offset: true }).regex(authenticationEventsParamsFromRegExp).optional(),
  to: zod.iso.datetime({ offset: true }).regex(authenticationEventsParamsToRegExp).optional(),
  cursor: zod
    .string()
    .min(1)
    .max(authenticationEventsParamsCursorMax)
    .regex(authenticationEventsParamsCursorRegExp)
    .optional(),
  limit: zod
    .int()
    .min(1)
    .max(authenticationEventsParamsLimitMax)
    .default(authenticationEventsParamsLimitDefault),
});

export type AuthenticationEventsParams = zod.input<typeof AuthenticationEventsParams>;
export type AuthenticationEventsParamsOutput = zod.output<typeof AuthenticationEventsParams>;
